import { jsxs, jsx } from 'react/jsx-runtime';
import { cn, User } from '@liveblocks/react-ui/_private';
import { NodeViewWrapper } from '@tiptap/react';
import { forwardRef } from 'react';

const MENTION_CHARACTER = "@";
const Mention = forwardRef((props, forwardedRef) => {
  const id = props.node.attrs.id;
  return /* @__PURE__ */ jsxs(NodeViewWrapper, {
    className: cn(
      "lb-root lb-tiptap-mention",
      props.selected ? "lb-mention-selected" : null
    ),
    as: "span",
    ref: forwardedRef,
    children: [
      MENTION_CHARACTER,
      /* @__PURE__ */ jsx(User, {
        userId: id
      })
    ]
  });
});

export { Mention };
//# sourceMappingURL=Mention.js.map
